module.exports = __webpack_public_path__ + "img/client31.db4a130e.svg";